/**
 * @fileoverview Task list column definitions (MOR-707)
 *
 * Split out of `task-list-view.tsx` (react-refresh/only-export-components) —
 * every list column, in display order. `title` is always shown; the rest can
 * be hidden via the surface's Columns menu.
 */

export const TASK_LIST_COLUMNS: Array<{
  key: string;
  label: string;
  className?: string;
  defaultVisible: boolean;
  /** Only meaningful in the cross-job workspace view (e.g. "My Tasks"). */
  crossJobOnly?: boolean;
}> = [
  { key: "title", label: "Task", defaultVisible: true },
  { key: "job", label: "Job", defaultVisible: true, crossJobOnly: true },
  { key: "status", label: "Status", defaultVisible: true },
  { key: "assignee", label: "Assignee", defaultVisible: true },
  { key: "assignor", label: "Assigned by", defaultVisible: false },
  { key: "priority", label: "Priority", defaultVisible: true },
  { key: "category", label: "Category", defaultVisible: false },
  { key: "plannedDate", label: "Planned", defaultVisible: true },
  { key: "date", label: "Due", defaultVisible: true },
  { key: "labels", label: "Labels", defaultVisible: true },
];
